import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, EmailVerificationStep } from '../../store/Auth/EmailVerificationStore';
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/
import SilvermouseInfo from './SilvermouseInfo';
import '../../css/auth.css';
import { Redirect } from 'react-router-dom';
import { AppLogo } from '../Controls/AppLogo';
import { IsSoundmouse } from '../../tools/toolkit';

class EmailVerification extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let guid = this.props.match.params['guid'];

        if (guid !== undefined) {
            this.props.verifyEmailByLink(guid);
        }
        else {
            this.props.getEmailVerificationStatus();
        }
    }
    handleResendEmail = (event) => {
        event.preventDefault();

        if (this.props.step === EmailVerificationStep.None || this.props.step === EmailVerificationStep.Expired || this.props.step === EmailVerificationStep.Sent) {
            this.props.resendEmailVerificationLink();
        }
    }

    handleVerifyEmail = (event) => {
        event.preventDefault();

        if (this.props.step === EmailVerificationStep.None || this.props.step === EmailVerificationStep.Expired) {
            this.props.sendEmailVerificationLink();
        }
        else if (this.props.step === EmailVerificationStep.Completed) {
            this.props.goGateway();
        }
        else if (this.props.step === EmailVerificationStep.EmailAddressVerified) {
            window.location = '/';
        }
    }

    renderWarningMessage() {
        if (this.props.hasErrorOccured) {
            return (
                <h3 className='form-group text-left'>
                    <Octicon icon={getIconByName('alert')} className='text-warning mr-2' />
                    {this.props.errorData.message}
                </h3>
            );
        }
    }

    renderStep() {
        // Intro.
        if (this.props.step === EmailVerificationStep.None) {
            return (
                <div role="alert">
                    <h2 className='mt-2'>Validating your email address</h2>
                    <p>The email address registered against this account needs to be validated.</p>
                    <br />
                    <p>Please click on the Send Email Validation Link button below to request a link to validate your email.</p>
                    <br />
                </div>
            );
        }
        else if (this.props.step === EmailVerificationStep.Logout) {
            return <SilvermouseInfo />;
        }
        // Email Validation Sent.
        else if (this.props.step === EmailVerificationStep.Sent) {
            return (
                <div role="alert">
                    <h2 className='mt-2'>Your email validation link has been sent</h2>
                    <p>An email with a validation link has been sent to your registered email account. Please click this link to validate your email. This link will expire in 48 hours.</p>
                    <br />
                    <p>Please contact support if you do not receive this email.</p>
                    <br />
                    {this.renderResendButton()}
                </div>
            );
        }
        // Do we need this?
        else if (this.props.step === EmailVerificationStep.Completed) {
            return (
                <div>
                    <h2 className='mt-2'>Email Verification Completed</h2>
                    <p></p>
                    <br />
                </div>
            );
        }
        // When you click on a Validation Link (NOT EXPIRED).
        else if (this.props.step === EmailVerificationStep.EmailAddressVerified) {
            return (
                <div>
                    <h2 className='mt-2'>Email address validated</h2>
                    <p>Your registered email address has now been validated.</p>
                    <br />
                </div>
            );
        }
        // When you click on a Validation Link (EXPIRED).
        else if (this.props.step === EmailVerificationStep.Expired) {
            return (
                <div>
                    <h2 className='mt-2'>Your email validation link expired</h2>
                    <p>This link has expired. A new link will be sent to your registered email address when you next login.</p>
                    <br />
                </div>
            );
        }
    }

    renderIcon() {
        let iconClass = 'dotPrimary';

        if (this.props.hasErrorOccured || this.props.step === EmailVerificationStep.Expired) {
            iconClass = 'dotError';
        }
        else if (this.props.step === EmailVerificationStep.Completed) {
            iconClass = 'dotSuccess';
        }

        return <Octicon icon={getIconByName('mail')} className={`dot ${iconClass}`} />;
    }

    renderActionButton() {
        let buttonText = 'Send Email Validation Link';

        if (this.props.step === EmailVerificationStep.Completed || this.props.step === EmailVerificationStep.Sent) {
            return (
                <div className='form-group text-right' style={{ height: '20px' }} />
            );
        }
        else if (this.props.step === EmailVerificationStep.Expired) {
            if (this.props.match.params['guid']) {
                return (
                    <div className='form-group text-right' />
                );
            }
            else {
                buttonText = 'Resend';
            }
        }
        else if (this.props.step === EmailVerificationStep.EmailAddressVerified) {
            buttonText = 'Sign In';
        }

        if (this.props.step === EmailVerificationStep.Logout) {
            return '';
        }

        return (
            <div className='form-group text-right' >
                <button className='button button-primary' onClick={this.handleVerifyEmail}>{buttonText}</button>
                <div style={{ clear: 'both' }} />
            </div>
        );
    }

    renderResendButton() {
        if (this.props.previousStep !== EmailVerificationStep.Expired
            && this.props.previousStep !== EmailVerificationStep.None) {
            return (
                <div className='form-group text-right ml-2' style={{ float: 'right' }}>
                    <button className='button button-primary' onClick={this.handleResendEmail}>Resend</button>
                </div>
            );
        }
        return '';
    }

    render() {
        if (this.props.step === EmailVerificationStep.Gateway) {
            return <Redirect to='/Gateway' />;
        }

        let logoAlign = 'text-left';

        if (IsSoundmouse) {
            logoAlign = 'text-center';
        }

        return (
            <div role='main' className='pt-3'>
                <h1 class='visuallyhidden'>Email Verification Page</h1>
                <div className='row justify-content-center'>
                    <div className='text-center'>
                        <div className='loginLogo'>
                            <div className={logoAlign}>
                                <AppLogo />
                            </div>
                        </div>
                        <div className='loginVerificationBox'>
                            <div className='text-left'>
                                {this.renderIcon()}
                                <form>
                                    {this.renderStep()}
                                    {this.renderWarningMessage()}
                                    {this.renderActionButton()}
                                </form>
                            </div>
                        </div>
                        <div className='pt-2 loginSeperator'>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default connect(
    state => state.emailVerification,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(EmailVerification);



// WEBPACK FOOTER //
// ./src/components/Auth/EmailVerification.js